<template>
  <div class="reView">
    <div class="title">复核清单</div>
    <div class="noData" v-if="reviewList == ''">暂无数据</div>
    <div class="cont" v-else>
      <el-checkbox-group v-model="reviewCheck" @change="handleCheckedChange">
      <el-collapse v-model="activeNames">
        <el-collapse-item :name="item.id" class="item" v-for="(item,index) in reviewList" :key="index">
          <template slot="title">
            <div class="tit flex">
              <div class="titCont flex">
                <span>入库单号：{{item.order_id}}</span>
                <span>入库时间：{{item.time}}</span>
                <span>总数量：{{item.count}}</span>
              </div>
              <el-checkbox :label="item.id"></el-checkbox>
            </div>
          </template>
          <div class="itemCont" v-for="(product,index2) in item.detail" :key="index2">
            <div class="itemInfo">
              <i>{{item.location_id}}</i>
              <span>数量：1</span>
              <span>批号：{{product.lotno}}</span>
              <span>规格：{{product.spec}}</span>
              <span>效期：{{product.validdate}}</span>
              <span>生产日期：{{product.proddate}}</span>
            </div>
            <div class="name">{{product.name}}</div>
            <div class="itemTips">
              <div class="flexItem">
                <span>EPC：{{product.ascii}}</span>
              </div>
              <div class="flexItem">
                <span>供应商：{{product.supplier}}</span>
                <!-- <p>{{product.supplier}}</p> -->
              </div>
              <div class="flexItem">
                <span>注册证号：{{product.regno}}</span>
                <!-- <p>{{product.regno}}</p> -->
              </div>
              <!-- <div class="flexItem">
                <span>批号</span>
                <p>{{product.lotno}}</p>
              </div>
              <div class="flexItem">
                <span>生产日期</span>
                <p>{{product.proddate}}</p>
              </div>
              <div class="flexItem">
                <span>有效期</span>
                <p>{{product.validdate}}</p>
              </div> -->
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      </el-checkbox-group>
    </div>
    <div class="btCont flex">
      <div class="left flex">
        <el-checkbox-button :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox-button>
        <div class="tips">请勾选后验证指纹确认复核选项</div>
      </div>
      <el-button @click="backUp">返回</el-button>
    </div>
    <div class="errorLogin" v-if="isErrorLogin == true"><i class="el-icon-warning"></i>请重新验证...</div>
    <mqttws :topic="topic" :msg="msg" :isConnect="isConnect" ref="mqttws"  @getMessage="getMessage"></mqttws>
    <currtime :isShowInfo="false"></currtime>
  </div>
</template>
<script>
import currtime from '../../../../assets/currTime'
import mqttws from '../../../../assets/mqttws'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { wareApi,loginApi } from "../../../../../static/js/api.js"
import { checkData,hexCharCodeToAscii } from '../../../../../static/js/utils/util.js'
import * as config from '../../../../../static/js/config.js';
import { showLoading,hideLoading,localUserInfo } from '../../../../../static/js/utils/utility.js'
import noUserMp3 from '../../../../../static/mp3/noUser.mp3'
export default {
  name:'reView',
  data() {
    return {
      topic:'/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol',
      msg:'',
      isConnect:true,//是否默认订阅
      
      reviewList:[],//复核列表
      checkAll: false,
      reviewCheck:[],
      isIndeterminate: true,

      activeNames:'',

      isErrorLogin:false,//登录错误
      loginNumTip:0,
      logintime:5,//登录提示超时
      logintimeStatus:'',//登录提示超时状态

      isReviewTips:false,//复核提示
    }
  },
  async created(){
    this.medicalReview()
    console.log(hexCharCodeToAscii('30303030220984'))
  },
  components:{
    mqttws,
    currtime,
  },
  methods:{
    
    //接收mqtt信息
    getMessage(data){
      console.log(data)
      var that = this;
      var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
      var num = checkData(str)
      var bbc = data.substr(data.length-2)
      var type = str.substring(26,30)
      if(type == 'df0a'){
        var lastTwo2 = str.substring(34,36)
        var id = str.substring(str.length-4,str.length)
        if(lastTwo2 == 55 && num == bbc){
          that.getLogin(id)
        }else{
          that.$message({
            message: '暂无该用户！',
            type: 'error',
            duration:1000
          });
          // text2Audio('暂无该用户')
          var url = noUserMp3
          var audio = new Audio(url);
          audio.src = url;
          audio.play();
        }
      }
    },
    //登录提示超时
    loginTime(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.logintimeStatus)
        that.loginNumTip=0
        that.isErrorLogin = false
      } else {
        that.logintime=wait
        that.logintime--;
        that.logintimeStatus = setTimeout(function() {
          that.loginTime(that.logintime);
        },1000);
      }
    },
    //登录
    async getLogin(id){
      var that = this
      var data = {
        'login_type': 'finger',
        "cabinet_id": config.deviceId,
        'finger_id':id
      }
      if(that.reviewCheck == ''){
        that.$message.error('请先勾选需要复核的订单~')
        return
      }
      var res = await loginApi.userLogin(data)
      if (res.meta.code == 200) {
        if(that.loginNumTip > 1){
          clearTimeout(that.logintimeStatus)
        }
        that.isErrorLogin = false;//关闭错误提示
        that.loginNumTip = 0

        if(res.body.level.indexOf('STOCK_RECHECK') != -1){
          that.updateReview(res.body)
        }else{
          that.$message.error('您没有复核权限~')
        }
      } else {
        // that.$message.error(res.meta.message)
        if(that.loginNumTip == 0){
          if(that.isErrorLogin == false){
            that.$message.error(res.meta.message)
          }
        }else{
          that.logintime=5;
          if(that.loginNumTip == 1){
            that.loginTime(that.logintime)
          }
          that.isErrorLogin = true
        }
        that.loginNumTip+=1;
      }
    },
    //提交复核
    async updateReview(body){
      var that = this;
      var dataObj = {
        'id': that.reviewCheck,//需要复核的订单id数组
        'user_id': body.user_id,
        'user': body.user_name,
        'level': body.level,
        'cabinetid': config.deviceId
      }
      var res = await wareApi.updateReview(dataObj)
      if(res.meta.code == 200){
        that.$message.success('复核成功！')
        that.reviewCheck=[]
        that.isIndeterminate = true
        that.medicalReview()
      }else{
        that.$message.error(res.meta.message)
      }
    },
    //获取复核列表
    async medicalReview(){
      var that = this;
      var dataObj = {
        'cabinetid': config.deviceId,
      }
      var res = await wareApi.medicalReview(dataObj)
      if(res.meta.code == 200){
        if(res.body!=''){
          that.activeNames = res.body[0].id
          for(var i in res.body){
            for(var x in res.body[i].detail){
              res.body[i].detail[x].ascii = hexCharCodeToAscii(res.body[i].detail[x].rfid)
            }
          }
        }
        that.reviewList = res.body
      }else{
        that.$message.error(res.meta.message)
      }
    },
    //全选
    handleCheckAllChange(val) {
      // console.log('全选',val)
      var arr = []
      for(var i in this.reviewList){
        arr.push(this.reviewList[i].id)
      }
      arr = Array.from(new Set(arr))
      // console.log(arr)
      this.reviewCheck = val ? arr : [];
      this.isIndeterminate = false;
    },
    //选择多个
    handleCheckedChange(value) {
      // console.log('单选',value)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.reviewList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.reviewList.length;
    },
    //返回
    backUp(){
      // this.$refs.mqttws.disconnect()
      this.$router.push({
        path:'/unmanned/wrcIndex',
      })
    },
    
  },
}
</script>
<style lang="less">
.reView{
  .errorLogin{
    text-align: left;
    position: fixed;
    z-index: 3002;
    background: #fff;
    border-radius: 0.1rem;
    font-size: 0.36rem;
    color: #666;
    padding: 0.2rem;
    top: 20%;
    left: 50%;
    width: 20%;
    margin-left: -10%;
    i{ margin-right: 0.1rem; }
  }
  .el-collapse{
    border-bottom: none;
  }
  .el-collapse-item__header{
    background-color: rgba(254, 254, 254, .25);
    height: auto;
    line-height: 1;
  }
  .el-collapse-item__arrow{
    font-size: 0.4rem;
    color:#fff;
    flex-shrink: 0;
    margin: 0 0.25rem 0 0;
  }
  .el-collapse-item__wrap{
    background-color: rgba(254, 254, 254, .11);
    border-bottom: none;
  }
  .el-collapse-item__content{ 
    padding-bottom: 0;
    line-height: 1;
  }
  .el-checkbox-button:first-child .el-checkbox-button__inner{
    border: none;
    border-radius: 0.12rem;
    padding: 0 0.6rem;
    font-size: 0.4rem;
    height: 0.94rem;
    line-height: 0.94rem;

  }
  .el-checkbox__input+.el-checkbox__label{ display: none;}
  .el-checkbox__inner{
    width: 0.5rem;
    height: 0.5rem;
    box-sizing: inherit;
    &::after{
      content:"";
      border: 0.05rem solid #fff;
      border-left: 0;
      border-top: 0;
      height: 0.34rem;
      left: 0.13rem;
      position: absolute;
      top: -0.02rem;
      width: 0.12rem;
    }
  }
  .el-checkbox__input.is-checked .el-checkbox__inner{
    border:0.04rem solid #fff;
    background: none;
  }
  .noData{
    height: calc( 100vh - 2.54rem);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.3rem;
    color: #999;
  }
  .cont{
    height: calc( 100vh - 2.54rem);
    overflow: auto;
    .item{
      .itemCont{
        font-size: 0.3rem;
        color: #fff;
        border-bottom: 0.01rem solid #75a3c2;
        .itemTips{
          // border-top: 0.01rem solid #75a3c2;
          padding: 0.14rem 0.25rem;
          display: flex;
          align-items: center;
          font-size: 0.26rem;
          color: #e5e5e5;
          .flexItem{
            margin-right: 0.9rem;
            &:last-child{
              margin-right: 0;
            }
          }
          p{
            color: #bfbfbf;
            margin-top: 0.06rem;
          }
        }
        .name{
          padding: 0 0.25rem 0rem;
          font-size: 0.36rem;
          font-weight: bold;
        }
        .itemInfo{
          padding: 0.1rem 0.25rem;
          display: flex;
          align-items: center;
          i{
            width: 0.38rem;
            height:0.38rem;
            border-radius: 50%;
            background: #fff;
            color: #00a0e9;
            text-align: center;
            line-height: 0.38rem;
            margin-right: 0.2rem;
          }
          span{
            margin-right: 0.8rem;
          }
        }
      }
      .tit{
        flex-grow: 1;
        padding: 0 1rem 0 0.25rem;
        height: 0.7rem;
        font-size: 0.3rem;
        color: #fff;
        justify-content: space-between;
        align-items: center;
        .titCont{
          span{ margin-right: 0.3rem;}
        }
      }
    }
  }
  .title{
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.36rem;
  }
  .btCont{
    z-index: 99;
    padding: 0.3rem;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(0, 0, 0, .21);
    .left{
      align-items: center;
      .tips{
        margin-left: 0.28rem;
        font-size: 0.4rem;
        color: #f36c6c;
      }
      .el-checkbox-button .el-checkbox-button__inner{
        height: 0.94rem;
        padding: 0 0.6rem;
        font-size: 0.4rem;
        color: #fff;
        font-weight: bold;
        border: none;
        border-radius: 0.12rem;
        line-height:0.94rem;
        background: linear-gradient(#4aaafe, #0769be);
      }
      .el-checkbox-button.is-checked .el-checkbox-button__inner{
        height: 0.94rem;
        padding: 0 0.6rem;
        font-size: 0.4rem;
        color: #fff;
        font-weight: bold;
        border: none;
        border-radius: 0.12rem;
        line-height:0.94rem;
        background: linear-gradient(#0769be, #4aaafe);
      }
    }
    .el-button{
      height: 0.94rem;
      // width: 2.54rem;
      padding: 0 0.6rem;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/CToolCabinet/page/reView/reView.vue